import React from 'react'
import logo from '../assets/LOGO.svg';
import { Link } from 'react-router-dom';

const CheckEmailPage = () => {
  return (
    <div className="App">
        <img src={logo} alt="logo" />
        <div className='forgotPasswordInfo'>
            <span
                style={{
                    fontFamily: 'var(--semibold-text-font-family)',
                    color: 'var(--tokens-colors-text-basic)',
                    fontSize: 'var(--info-text-font-size)',
                    fontWeight: 'var(--bottom-tab-lable-font-weight)',
                }}
            >
                Проверьте свою электроннуюю почту
            </span>
            <span
            style={{
                fontFamily: 'var(--regular-text-font-family)',
                color: 'var(--tokens-colors-text-basic)',
                width: '345px',
                textAlign: 'center',
                paddingTop: 'var(--tokens-paddings-gaps-container-basic)',
                fontSize: 'var(--semibold-text-font-size)',
                fontWeight: 'var(--regular-text-font-weight)',
                lineHeight: 'var(--regular-text-line-height)',
            }}
            >
                Если почта совпадает с адресом электронной почты, которая есть в нашей базе данных, мы отправим вам письмо с дальнейшими инструкциями по сбросу пароля.
                <br/>
                <br/>
                <br/>
                Если вы не получили письмо в течение 5 минут, проверьте папку "Спам"
            </span>
        </div>
        {/* Пока что никакое письмо повторно не отправляется. Возвращает на страницу авторизации*/}
        <Link to="/" className="backToLoginLink"> 
            Отправить письмо повторно
        </Link>
        <Link to="/" className="backToLoginLink">
            Вернуться, чтобы войти
        </Link>
    </div>
  )
}

export default CheckEmailPage